﻿import { debounce } from './lib/throttle-debounce';
import scss from 'scss';

export default class LoanSteps {
    constructor() {
        this.dom = {
            $: window.$,
            $window: $(window),
            $container: $('.loan-steps'),
            $list: $('.loan-steps-list'),
            $item: $('.loan-steps-number')
        };

        if (this.dom.$container.length) {
            this.init();
        }
    }

    init() {
        this.events();
        this.onResizeCallback();
    }

    setHeight(reset = false) {
        let height = 'auto';

        if (!reset) {
            height = this.dom.$list.find('.active .loan-steps-copy').outerHeight(true) + this.dom.$list.find('.loan-steps-number').height();
        }

        this.dom.$list.css('height', height);
    }

    onResizeCallback() {
        if (this.dom.$window.width() >= parseInt(scss['$sm'])) {
            this.setHeight(true);
        } else {
            this.setHeight();
        }
    }

    onClickItem(e) {
        let $item = $(e.currentTarget);

        if (this.dom.$window.width() >= parseInt(scss['$sm'])) {
            return;
        }

        $item.closest('li').addClass('active').siblings().removeClass('active');

        this.setHeight();
    }

    events() {
        this.dom.$item.on('click', this.onClickItem.bind(this));

        this.dom.$window.on('resize', debounce(120, this.onResizeCallback.bind(this)));
    }
}

document.addEventListener('DOMContentLoaded', () => new LoanSteps());
